import { VendorNetworkModal } from '@components/VendorNetworkModal';
import { calculateCategoryCounts } from '@components/VendorNetworkModal/utils/categoryCounts';
import AnalyticsConstants from '@constants/analytics';
import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useAppSelector } from '@redux/hooks';
import { TextBody } from '@tkww/orion-web-ds';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { useAtomValue } from 'jotai';
import React, { type FC, useState, useCallback, useMemo } from 'react';
import { storefrontsNetworkDataAtom } from '../../../../jotai/storefront/storefronts-network-pvrec';
import Styles from './styles.scss';

export const VendorNetworkBanner: FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	const vendor = useAppSelector((state) => state.vendor.vendorRaw);
	const storefrontsNetworkData = useAtomValue(storefrontsNetworkDataAtom);
	const { track } = useAnalyticsContext();
	const { recommendationCount, vendorNetworkRecCount } = useMemo(
		() => calculateCategoryCounts(storefrontsNetworkData.network),
		[storefrontsNetworkData.network],
	);
	const image = vendor?.storefrontCard?.url;

	const trackCTAClick = useCallback((): void => {
		track({
			event: AnalyticsConstants.CTA_CLICKED,
			properties: {
				sourcePage: 'storefront',
				action: 'vendor network',
				selection: 'open',
				reason: 'open vendor network',
				vendorNetworkRecCount,
				recommendationCount,
			},
		});
	}, [track, recommendationCount, vendorNetworkRecCount]);

	const handleClick = useCallback(() => {
		trackCTAClick();
		setIsOpen(true);
	}, [trackCTAClick]);

	if (!vendor) return null;

	return (
		<>
			<button className={Styles.banner} onClick={handleClick} type="button">
				<div className={Styles.contentWrapper}>
					<TextBody size="lg" bold className={Styles.text}>
						See vendors couples often book at {vendor.name}
					</TextBody>
				</div>
				<div className={Styles.imageWrapper}>
					<div className={Styles.mainImageWrapper}>
						{image && (
							<div
								className={Styles.mainImage}
								style={{ backgroundImage: `url(${image})` }}
							/>
						)}
						<div className={Styles.imageShadow} />
					</div>
					<div className={Styles.hearts}>
						<Icon
							name="heart-expressive"
							color="brand"
							size="sm"
							className={Styles.heartSmall}
							aria-label="Favorites"
						/>
						<Icon
							name="heart-expressive"
							color="brand"
							size="lg"
							className={Styles.heartLarge}
							aria-label="Favorites"
						/>
					</div>
					<div className={Styles.arrowWrapper}>
						<Icon name="arrow-right" color="dark" aria-label="Next" />
					</div>
				</div>
			</button>
			<VendorNetworkModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
		</>
	);
};
